import { BaseProfile } from '@lib/core/model';

export class ProfileMapper {
  public static map(data: any): BaseProfile {
    return data ? new BaseProfile(data.id, data.uuid, data.name, data.type) : null;
  }
}
